var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTargetFilledDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7962 4C13.6554 4 14.1146 5.01192 13.5488 5.6585L8.75258 11.1399C8.35417 11.5952 7.64584 11.5952 7.24742 11.1399L2.45119 5.6585C1.88543 5.01192 2.34461 4 3.20377 4L12.7962 4Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTargetFilledDown);
export default __webpack_public_path__ + "static/media/target-filled-down.07be2ed0292aad079a337d1c0c12ab23.svg";
export { ForwardRef as ReactComponent };